type ChevronDownProps = {
	width?: number;
	height?: number;
	color?: string;
	strokeColor?: string;
	strokeWidth?: number;
	className?: string;
};

const ChevronDown = ({
	width,
	height,
	color,
	strokeColor,
	strokeWidth,
	className,
}: ChevronDownProps) => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width={width || 12}
			height={height || 6}
			className={`text-${color} fill-${color} ${className}`}
			viewBox='0 0 12 6'
		>
			<path
				fillRule='evenodd'
				stroke={strokeColor ?? color}
				strokeWidth={strokeWidth || 1.5}
				d='m6.319 5.582 4.56-4.613a.37.37 0 0 0 0-.548.443.443 0 0 0-.593 0L6.002 4.755 1.714.421a.443.443 0 0 0-.592 0 .37.37 0 0 0 0 .548l4.56 4.613a.44.44 0 0 0 .32.11c.113.005.23-.03.317-.11Z'
			/>
		</svg>
	);
};

export default ChevronDown;
